/**
 * MainQueryBoundary — a labelled divider marking where the WITH clause's CTE
 * definitions end and the outer/main query begins (Task cte-context, COM-10:
 * "the outer query is entirely below the fold" with nothing marking the
 * boundary). Purely presentational; `SelectRenderer` mounts it between
 * `<CteSection>` and `<FromSection>`, gated on `cteOutline.hasWith` — no WITH
 * clause, no marker (there is nothing to bound).
 */

// Small structural label, not app copy — vqeCopy.ts is owned by a held
// §4b-ii-fix lane this task avoids colliding with.
// TODO(vqe-copy): consolidate
const MAIN_QUERY_BOUNDARY_LABEL = 'Main query';

export function MainQueryBoundary() {
  return (
    <div
      className="flex w-full items-center gap-2 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground/70"
      data-testid="vqe-main-query-boundary"
    >
      <span aria-hidden="true" className="h-px flex-1 bg-border" />
      <span>{MAIN_QUERY_BOUNDARY_LABEL}</span>
      <span aria-hidden="true" className="h-px flex-1 bg-border" />
    </div>
  );
}
